/* eslint-disable max-len */
export const ru = {
  brand: 'Рубцов',
  seo: {
    siteName: 'Рубцов Михаил — разработчик',
    ogLocale: 'ru_RU',
    home: {
      title: 'Рубцов Михаил — разработчик с 10+ годами в IT',
      description: 'Разработчик с 10+ годами в IT — в индустрии с 2013 года. Веб-приложения, боты, парсеры, интеграции. Руководил командами разработки до 35 человек, руки по-прежнему в коде.',
    },
    projects: {
      title: 'Проекты — Рубцов Михаил',
      description: 'Пет-проекты и запущенные продукты Михаила Рубцова: fincollect.cz, py-py.ru, fants.ru, jeetpay.cc, jeetbot.cc, mew-craft.ru, royal-shine.ru, 1-2dev.ru.',
    },
  },
  contacts: {
    telegramUrl: 'https://t.me/MrEarnestWhim',
    telegramHandle: '@MrEarnestWhim',
    email: '5494567@gmail.com',
    phoneDisplay: '+7 (939) 7000-772',
    phoneHref: 'tel:+79397000772',
  },
  header: {
    about: 'Обо мне',
    steps: 'Что я делаю',
    projects: 'Проекты',
    contact: 'Связаться',
    toHome: 'На главную',
    langSwitch: 'EN',
  },
  preview: {
    name: 'Рубцов Михаил',
    tagline: 'Разработчик с 10+ годами в IT — в индустрии с 2013 года',
    subline: 'Руководил командами разработки до 35 человек, руки по-прежнему в коде',
    ctaTelegram: 'Написать в Telegram',
    ctaEmail: 'Написать на почту',
    stats: [
      { value: '10+', label: 'лет в IT' },
      { value: '35+', label: 'человек в команде' },
          { value: '20+', label: 'продуктов с нуля' },
      { value: '2013', label: 'в индустрии с' },
    ],
  },
  about: {
    heading: 'Обо мне',
    parts: [
      { text: 'Я разработчик и руководитель в одном лице. Больше всего люблю собирать системы с нуля — архитектуру, команды и процессы. Последние годы вёл направление разработки, а сейчас открыт к роли разработчика или менеджера. Пишу на ' },
      { chip: true, color: 'green', text: 'Python' },
      { text: ', ' },
      { chip: true, color: 'purple', text: 'JavaScript' },
      { text: ', ' },
      { chip: true, color: 'green', text: 'PHP' },
      { text: ' и ' },
      { chip: true, color: 'purple', text: 'C/C++' },
      { text: ', новое осваиваю быстро.' },
    ],
  },
  experience: {
    jobs: [
      {
        company: 'ООО «7Tehc»',
        role: 'Руководитель направления разработки',
        period: 'Март 2023 — Июнь 2025',
        duration: '2 года 4 мес',
        highlights: 'Микросервисная архитектура. Две кросс-функциональные команды, 35+ человек: найм, roadmap, коммуникация с CEO и инвесторами.',
      },
      {
        company: 'ООО «Интелкон»',
        role: 'Руководитель IT-домена, архитектор',
        period: 'Декабрь 2020 — Февраль 2023',
        duration: '2 года 3 мес',
        highlights: 'Построил IT-направление с нуля: команда до 32 человек, два продукта запущены.',
      },
      {
        company: 'ООО «OutGame»',
        role: 'Тех.лид',
        period: 'Июль 2019 — Октябрь 2020',
        duration: '1 год 4 мес',
        highlights: 'Архитектура и микросервисный бэкенд площадки с нуля, Steam trading bots. Нанял 2 backend-разработчиков.',
      },
      {
        company: 'ООО «Squilla Fund»',
        role: 'Главный программист-архитектор',
        period: 'Ноябрь 2018 — Июль 2019',
        duration: '9 мес',
        highlights: 'Кастомный oAuth-сервис (подобие LDAP), SDK для ноды Ethereum, парсинг больших данных в графовые модели.',
      },
    ],
    projectsLink: 'Смотреть проекты →',
  },
  steps: {
    items: [
      {
        headingParts: ['Мой стек'],
        list: [
          'Python',
          'JavaScript',
          'C\\C++',
          'PHP',
        ],
      },
      {
        headingParts: ['Что разрабатывал'],
        list: [
          'Боты (в т.ч. Steam-trade)',
          'Парсеры',
          'Работа с биржей и корректировками',
          'Сайты (веб-приложения)',
          'Real-Time чаты',
          'Интеграции (REST и не официальные)',
          'Реверс-инженеринг',
          'CRM, MDM, МИС, а также много других классов систем.',
          'Десктоп клиенты',
          'Плагины и моды для игр',
          'Браузерные расширения',
          'Создание Smart Contract в Ethereum',
        ],
      },
      {
        headingParts: ['А еще'],
        list: [
          'Работал по разным методологиям, в разных таск-трекерах, с разными командами и разными инструментами. Нанимал тоже... разных ¯\\_(ツ)_/¯',
          'Использую всё, что помогает или ускоряет в разработке/менеджменте. Сначала книги, потом гугл, сейчас ИИ, завтра AGI ¯\\_(ツ)_/¯',
        ],
      },
    ],
  },
  contact: {
    heading: 'Связаться',
    labels: { telegram: 'Telegram', email: 'Email', phone: 'Телефон' },
    noteStart: 'Любой способ связи — выбирайте удобный: пишите в ',
    noteMiddle: ' или на ',
    chipTelegram: 'телеграм',
    chipEmail: 'эл.почту',
  },
  projectsPage: {
    heading: 'Проекты',
    subline: 'Проекты, которые я запустил сам или с командой — от ATS-платформы до инфраструктуры Minecraft-сервера.',
    back: '← На главную',
    projects: {
      'pypy-ats': {
        title: 'PyPy ATS',
        subtitle: 'Applicant Tracking System',
        description: 'Платформа для управления полным циклом подбора персонала. От публикации вакансий и приёма заявок до проведения интервью и найма — всё в одном месте.',
        features: [
          {
            title: 'Воронка подбора',
            items: [
              'Канбан-доска с кастомными этапами для каждой вакансии',
              'Drag-and-drop перемещение кандидатов между стадиями',
              'Привязка кандидатов к нескольким вакансиям одновременно',
            ],
          },
          {
            title: 'Управление кандидатами',
            items: [
              'Профили с навыками, резюме, контактами и заметками',
              'Настраиваемые статусы и workflow',
              'Тестовые задания с файлами и ссылками',
              'Экспорт карточки кандидата в PDF',
            ],
          },
          {
            title: 'Планирование интервью',
            items: [
              'Рабочий график с учётом перерывов и выходных',
              'Автоматический расчёт свободных слотов',
              'Защита от пересечений в расписании',
              'Публичная страница записи — кандидат сам выбирает время',
            ],
          },
          {
            title: 'Карьерная страница',
            items: [
              'Публичный список открытых вакансий',
              'Форма отклика с загрузкой резюме',
              'Автоматическое создание кандидата из заявки',
            ],
          },
          {
            title: 'Опросники и оценка',
            items: [
              'Конструктор опросников с типами вопросов',
              'Привязка опросников к интервью',
              'Трекинг ответов и результатов',
            ],
          },
          {
            title: 'Уведомления и аналитика',
            items: [
              'Telegram-уведомления о новых заявках и интервью',
              'Кастомизируемые email-шаблоны с переменными',
              'Дашборд аналитики: воронка конверсии, графики по дням',
            ],
          },
        ],
        screenshotAlts: [
          'Посадочная страница',
          'Канбан-доска кандидатов',
          'Планирование интервью',
          'Карьерная страница',
          'Аналитика',
          'Настройки и шаблоны',
        ],
      },
      fants: {
        title: 'Fants.ru',
        subtitle: 'Игровая платформа для пар и компаний',
        description: 'Развлекательная платформа с коллекцией интерактивных игр и психологических тестов. Мультиплеер в реальном времени, система прогресса, чат и блог — полноценный продукт с SEO.',
        features: [
          {
            title: '7 интерактивных игр',
            items: [
              'Фанты — задания по уровням с таймерами и изображениями',
              'Правда или действие — классическая механика с пулом 100+ вопросов',
              'Я никогда не — режимы игры, детектор лжи, анонимные ответы',
              '52 задания на год — карточки с модификаторами и джокерами',
              'Сексополия — настольная игра с захватом клеток и очками',
              'Рулетка желаний — уровни накала, бонусные карты, стоп-слово',
              'Эротические кости — дефолтные и пользовательские наборы',
            ],
          },
          {
            title: '6 психологических тестов',
            items: [
              'Тест на раскрепощённость — 3 блока вопросов, перцентиль по базе',
              'Какой ты любовник — 4 категории оценки, многомерный результат',
              'Тест совместимости — парное прохождение, 5 блоков анализа',
              'Сексуальная суперсила — 8 типов с совместимостью и приёмами',
              'Сексуальный возраст — быстрая оценка уровня опыта',
              'Тайное желание — 7 категорий с психологией и рекомендациями',
            ],
          },
          {
            title: 'Игровые механики',
            items: [
              'Мультиплеер на 2-4 игрока с отслеживанием очерёдности',
              'Система уровней сложности и прогрессии внутри сессии',
              'Защита паролем — делитесь игрой без регистрации партнёра',
              'История игр и результатов тестов в личном кабинете',
            ],
          },
          {
            title: 'Пользователи и профили',
            items: [
              'Регистрация по email с верификацией',
              'Профиль с аватаром, интересами и настройками',
              'Сброс пароля и управление сессиями',
              'Cookie consent и GDPR-совместимость',
            ],
          },
          {
            title: 'Чат и контент',
            items: [
              'Личные и групповые чаты с отправкой изображений',
              'Инвайт-ссылки для групповых чатов',
              'Блог с CKEditor, SEO-оптимизацией и счётчиком просмотров',
              'FAQ с JSON-LD разметкой для поисковиков',
            ],
          },
          {
            title: 'Аналитика и мониторинг',
            items: [
              'Клиентское логирование JS-ошибок и блокировщиков',
              'Трекинг внешних реферреров и источников трафика',
              'Логирование email-рассылок со статусами',
              'Sentry для ошибок, Prometheus для метрик',
            ],
          },
        ],
        screenshotAlts: [
          'Главная страница',
          'Игровой процесс — Фанты',
          'Результат теста',
          'Чат',
          'Блог',
          'Профиль пользователя',
        ],
      },
      'royal-shine': {
        title: 'Royal Shine',
        subtitle: 'Платформа для бьюти-студии с онлайн-записью и личным кабинетом мастеров',
        description: 'Полноценная платформа для салона красоты: клиенты записываются онлайн через пошаговый виджет, а мастера управляют расписанием, записями, услугами и портфолио через личный кабинет. Telegram-уведомления, гибкие графики работы и автоматический расчёт слотов.',
        features: [
          {
            title: 'Онлайн-запись для клиентов',
            items: [
              'Пошаговый виджет: категория → услуга → мастер → свободная дата и время',
              'Автоматический расчёт доступных слотов с учётом занятости и перерывов',
              'Учёт подготовки и уборки — буферное время между записями',
              'Подтверждение и отмена записей',
            ],
          },
          {
            title: 'Личный кабинет мастера',
            items: [
              'Дашборд: записи на сегодня/завтра, статистика за неделю и месяц',
              'Управление записями — создание, редактирование, подтверждение, отмена',
              'База клиентов с историей визитов, количеством записей и суммой',
              'Управление портфолио — загрузка фото работ с модерацией',
              'CRUD услуг: название, цена, длительность, сопутствующие услуги',
            ],
          },
          {
            title: 'Гибкое расписание',
            items: [
              'Недельный график — настройка часов по каждому дню недели',
              'Сменный график — цикл X дней работы / Y дней отдых',
              'Обеденные перерывы и персональные тайм-оффы',
              'Превью рабочих дней на 14 дней вперёд',
              'Настройка горизонта записи — сколько дней вперёд доступно клиентам',
            ],
          },
          {
            title: 'Каталог услуг',
            items: [
              'Категории услуг: ногти, брови, ресницы и другие',
              'Каждая услуга — с ценой, длительностью и описанием',
              'Сопутствующие услуги — кросс-продажи в прайс-листе',
              'Активация/деактивация и флаг «только в прайсе» для необронируемых услуг',
            ],
          },
          {
            title: 'Портфолио работ',
            items: [
              'Галерея с фильтрацией по категориям',
              'Автогенерация миниатюр и увеличенных версий',
              'Модерация — мастер загружает, админ публикует',
              'Теги и ALT-описания для SEO',
            ],
          },
          {
            title: 'Уведомления и интеграции',
            items: [
              'Telegram-бот — мгновенные уведомления о новых записях',
              'Docker-контейнеризация для деплоя',
              'Telegram-сервис как отдельный микросервис',
            ],
          },
        ],
        screenshotAlts: [
          'Главный экран студии',
          'Виджет онлайн-записи',
          'Дашборд мастера',
          'Управление расписанием',
          'Каталог услуг',
          'Портфолио работ',
        ],
      },
      mewcraft: {
        title: 'mewCraft',
        subtitle: 'Кроссплатформенный лаунчер и инфраструктура Minecraft-проекта',
        description: 'Полная инфраструктура для Minecraft-проекта: десктопный лаунчер на C++/Qt с автообновлением мод-паков, бэкенд на Django с собственной системой аутентификации, совместимой с Mojang API, лендинг с онлайн-статусом серверов, личный кабинет с загрузкой скинов/плащей и иерархическая FAQ-система.',
        features: [
          {
            title: 'Десктопный лаунчер (C++/Qt 6)',
            items: [
              'Кроссплатформенность — Windows, macOS, Linux из одной кодовой базы',
              'Авторизация с JWT-токенами и безопасное хранение (Keychain / Credential Manager / libsecret)',
              'Автоматическая установка и обновление мод-паков по манифесту с SHA-256 верификацией',
              'Параллельная загрузка файлов с прогресс-баром и повторными попытками',
              'Автоопределение и установка нужной версии Java',
              'Настройки RAM, Java-аргументов и параметров запуска',
            ],
          },
          {
            title: 'API-бэкенд (Django + DRF)',
            items: [
              'JWT-аутентификация с ротацией refresh-токенов и rate limiting',
              'Управление серверами — публичные и приватные с per-user доступом и сроками',
              'Система мод-паков — манифесты с хешами, версионирование, CLI-генерация из директории',
              'Защищённая раздача файлов через nginx X-Accel-Redirect',
              'Проверка обновлений лаунчера через API',
              'Health check эндпоинт (БД + кэш)',
            ],
          },
          {
            title: 'Mojang-совместимый Auth API',
            items: [
              'Полная реализация session/join + hasJoined для мультиплеера',
              'Профили игроков с текстурами (UUID lookup, batch resolve)',
              'Раздача скинов и плащей по UUID',
              'Player attributes, blocklist, publickeys — полная совместимость с патченным authlib',
            ],
          },
          {
            title: 'Веб-портал и личный кабинет',
            items: [
              'Лендинг с онлайн-статусом серверов в реальном времени (Server List Ping)',
              'Регистрация по email с подтверждением через зашифрованную ссылку',
              'Личный кабинет — загрузка скинов и плащей с валидацией размеров PNG',
              'Сброс пароля через email',
            ],
          },
          {
            title: 'FAQ / Wiki система',
            items: [
              'Иерархическое дерево статей на django-mptt',
              'CKEditor 5 для редактирования контента',
              'Разграничение доступа — публичные, авторизованные, только для админов',
            ],
          },
          {
            title: 'DevOps и инфраструктура',
            items: [
              'Docker Compose — PostgreSQL + Redis + Django + nginx',
              'nginx: проксирование API, статика, X-Accel-Redirect для файлов паков',
              'Покрытие тестами 86% — auth, серверы, доступ, манифесты, файлы',
              'Ruff + mypy для линтинга и проверки типов',
            ],
          },
        ],
        screenshotAlts: [
          'Лаунчер — экран входа',
          'Лаунчер — список серверов',
          'Лаунчер — загрузка мод-пака',
          'Лендинг с серверами',
          'Личный кабинет — скины',
          'FAQ / Wiki',
        ],
      },
      fincollect: {
        title: 'Fincollect',
        subtitle: 'Сайт чешского коллекторского агентства (Прага)',
        description: 'Корпоративная платформа Fincollect SE — агентства по управлению задолженностью. Отдельные сценарии для должников и партнёров, справочные разделы и формы обращений.',
        features: [
          {
            title: 'Контентная структура',
            items: [
              'Разделы для клиентов и для партнёров — отдельные сценарии',
              'FAQ с ответами на частые вопросы',
              'Словарь юридических терминов простым языком',
            ],
          },
          {
            title: 'Обращения и контакты',
            items: [
              'Формы связи для клиентов',
              'Контактный блок с телефоном, адресом и почтой',
              'Страница политики персональных данных (GDPR)',
            ],
          },
        ],
        screenshotAlts: [
          'Главная страница',
          'Раздел для клиентов',
          'Раздел для партнёров',
          'FAQ и словарь терминов',
        ],
      },
      jeetdonate: {
        title: 'JeetDonate',
        subtitle: 'Платформа донатов для стримеров (jeetpay.cc)',
        description: 'Сервис приёма донатов для стримеров: настраиваемые виджеты для OBS, уведомления в реальном времени по WebSocket и управление страницей доната из личного кабинета.',
        features: [
          {
            title: 'Виджеты для OBS',
            items: [
              'GIF, звуки и анимации — полная кастомизация под стиль стрима',
              'Уведомления о донатах в виджете через активное WebSocket-соединение',
            ],
          },
          {
            title: 'Личный кабинет',
            items: [
              'Финансы: баланс, комиссии и история операций',
              'Настройка минимальной суммы доната',
              'Управление оформлением страницы доната',
            ],
          },
        ],
        screenshotAlts: [
          'Лендинг',
          'Кабинет стримера',
          'Настройка виджетов',
          'Страница доната',
        ],
      },
      jeetbot: {
        title: 'JeetBot',
        subtitle: 'Бот для Twitch, Kick и VK Live',
        description: 'Многофункциональный стриминговый бот: синтез речи сообщений чата, оверлей для модераторов, автоперевод и десятки утилит. Подписки для стримеров и зрителей.',
        features: [
          {
            title: 'Синтез речи (TTS)',
            items: [
              'Озвучка сообщений чата в эфире',
              'Большой выбор голосов, кастомные голоса по подписке',
            ],
          },
          {
            title: 'Mod Alerts — оверлей для модераторов',
            items: [
              'Вывод картинок, GIF и текста на экран прямо из браузера',
              'Настраиваемый холст с синхронизацией в OBS',
            ],
          },
          {
            title: 'Утилиты чата',
            items: [
              'Punto Switcher — исправление забытых раскладок',
              'Авто-пин сообщения на время стрима',
              'Конвертер валют, Shazam, автоперевод сообщений',
              'Уведомления об упоминаниях в Telegram',
            ],
          },
          {
            title: 'Монетизация',
            items: [
              'Подписки для стримеров (Starter / Streamer / Ultimate)',
              'Подписка для зрителей: личный лимит озвучки, премиум-голоса и иконки',
            ],
          },
        ],
        screenshotAlts: [
          'Лендинг',
          'Панель управления',
          'Настройка TTS',
          'Оверлей Mod Alerts',
        ],
      },
    },
  },
  notFound: {
    title: '404 — страница не найдена',
    text: 'Такой страницы нет. Загляните на главную — там всё самое важное.',
    back: '← На главную',
  },
};
